// Maps BE API terminology (val) to UI terminology (key)
export const BANK_ACCOUNT_STATUS = {
  PRIMARY: 'ACTIVE',
  INACTIVE: 'ARCHIVED',
  PENDING: 'INACTIVE',
  FAILED: 'FAILED',
};

// Maps UI label to status key, from above
export const BANK_ACCOUNT_STATUS_LABEL = {
  [BANK_ACCOUNT_STATUS.PRIMARY]: {
    text: 'Active',
    color: 'green',
    order: 1,
  },
  [BANK_ACCOUNT_STATUS.INACTIVE]: {
    text: 'Inactive',
    color: 'gray',
    order: 2,
  },
  [BANK_ACCOUNT_STATUS.PENDING]: {
    text: 'In Review',
    color: 'orange',
    order: 3,
  },
  [BANK_ACCOUNT_STATUS.FAILED]: {
    text: 'Failed',
    color: 'red',
    order: 4,
  },
};

// Boarding state as the payment provider sees it, distinct from the account status above.
// Sola's boarding call can outlive the HTTP request, so an account exists locally before the
// processor has confirmed it.
export const PROVIDER_STATUS = {
  SUBMIT_PENDING: 'SUBMIT_PENDING',
  SUBMIT_UNKNOWN: 'SUBMIT_UNKNOWN',
};

// Shown INSTEAD of the account status while boarding is unresolved, so an account that is
// merely slow is not mistaken for one that is ready.
export const PROVIDER_STATUS_LABEL = {
  [PROVIDER_STATUS.SUBMIT_PENDING]: {
    text: 'Submitting',
    color: 'orange',
    order: 3,
  },
  [PROVIDER_STATUS.SUBMIT_UNKNOWN]: {
    text: 'Needs Review',
    color: 'red',
    order: 4,
  },
};

// Error messaging
export const ERROR_MESSAGE = {
  EMPTY: 'Please fill in all fields',
  AGREEMENTS: 'Please check both agreements',
};
